._ProgramInviteTemplate_1dk0y_1 {
  padding-top: 20px;
}